import { Pipe, PipeTransform } from '@angular/core';
import { Http } from '@angular/http';
import { Dictionary } from '../models/dictonary.model';
import { LocalStorageService } from '../services/local-storage.service';
import { Observable, ReplaySubject } from 'rxjs';
@Pipe({
    name: 'translate'
})
export class TranslatePipe implements PipeTransform {

    translationCache = new Dictionary<string>();

    constructor(private http: Http,
                private localStorageService: LocalStorageService) {
        this.translationCache = this.localStorageService.getTranslationCache();
    }

    transform(value: string) {
        const cachedValue = this.translationCache[value];
        // cachedValue = null;
        if (cachedValue == null) {
            const prom = this.http.get('/umbraco/api/Dictionary/Translate?key=' + value, null).map(r => r.json());
            prom.subscribe((data) => {
                this.localStorageService.saveTranslation(value, data);
            });
            return prom;
        } else {
            const dictionaryVal = new ReplaySubject<String>();
            dictionaryVal.next(cachedValue);
            return dictionaryVal;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/translate.pipe.ts